/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Additional invoiced charges to be shown on the Customs Declaration Commercial Invoice.
 */
export type CustomsInvoicedCharges = {
  /**
   * Currency for the invoiced charges amounts incurred on the end consumer.
   */
  currency: string;
  /**
   * Total shipping paid by the buyer.
   */
  totalShipping?: string | undefined;
  /**
   * Total taxes paid by the buyer.
   */
  totalTaxes?: string | undefined;
  /**
   * Total duties paid by the buyer.
   */
  totalDuties?: string | undefined;
  /**
   * Other fees paid by the buyer.
   */
  otherFees?: string | undefined;
};

/** @internal */
export const CustomsInvoicedCharges$inboundSchema: z.ZodType<
  CustomsInvoicedCharges,
  z.ZodTypeDef,
  unknown
> = z.object({
  currency: z.string(),
  total_shipping: z.string().optional(),
  total_taxes: z.string().optional(),
  total_duties: z.string().optional(),
  other_fees: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "total_shipping": "totalShipping",
    "total_taxes": "totalTaxes",
    "total_duties": "totalDuties",
    "other_fees": "otherFees",
  });
});

/** @internal */
export type CustomsInvoicedCharges$Outbound = {
  currency: string;
  total_shipping?: string | undefined;
  total_taxes?: string | undefined;
  total_duties?: string | undefined;
  other_fees?: string | undefined;
};

/** @internal */
export const CustomsInvoicedCharges$outboundSchema: z.ZodType<
  CustomsInvoicedCharges$Outbound,
  z.ZodTypeDef,
  CustomsInvoicedCharges
> = z.object({
  currency: z.string(),
  totalShipping: z.string().optional(),
  totalTaxes: z.string().optional(),
  totalDuties: z.string().optional(),
  otherFees: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    totalShipping: "total_shipping",
    totalTaxes: "total_taxes",
    totalDuties: "total_duties",
    otherFees: "other_fees",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CustomsInvoicedCharges$ {
  /** @deprecated use `CustomsInvoicedCharges$inboundSchema` instead. */
  export const inboundSchema = CustomsInvoicedCharges$inboundSchema;
  /** @deprecated use `CustomsInvoicedCharges$outboundSchema` instead. */
  export const outboundSchema = CustomsInvoicedCharges$outboundSchema;
  /** @deprecated use `CustomsInvoicedCharges$Outbound` instead. */
  export type Outbound = CustomsInvoicedCharges$Outbound;
}

export function customsInvoicedChargesToJSON(
  customsInvoicedCharges: CustomsInvoicedCharges,
): string {
  return JSON.stringify(
    CustomsInvoicedCharges$outboundSchema.parse(customsInvoicedCharges),
  );
}

export function customsInvoicedChargesFromJSON(
  jsonString: string,
): SafeParseResult<CustomsInvoicedCharges, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CustomsInvoicedCharges$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CustomsInvoicedCharges' from JSON`,
  );
}
